export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between animate-rise">
    <div className="space-y-2">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
      {description && <p className="max-w-2xl text-sm text-slate-600 sm:text-base">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
